'use client';

import TermsPageUI from './TermsUI';
import { TermsDict } from '@/lib/dictionaries';

interface TermsPageWrapperProps {
  dict: TermsDict;
  locale: string;
}

export default function TermsPageWrapper({
  dict,
  locale,
}: TermsPageWrapperProps) {
  return (
    <>
      <TermsPageUI dict={dict} locale={locale} />
    </>
  );
}
